import ConfirmationModal from "@/lib/modal/ConfirmationModal";
import $api from "@/lib/queries/openapi";
import { useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router";

export default function AutoCompleteSubPartsModal({
  partId,
  done,
  cancel,
}: {
  partId: string;
  done: (ids: string[]) => void;
  cancel: () => void;
}) {
  const queryClient = useQueryClient();
  const { teamSlug } = useParams();

  const { mutate, isPending } = $api.useMutation(
    "post",
    "/api/teams/{team_slug}/requested_parts/{id}/complete_estimates",
    {
      onSuccess: async (partIdsToSkip) => {
        await queryClient.invalidateQueries({
          queryKey: ["get", "/api/teams/{team_slug}/requested_parts/{id}"],
        });
        await queryClient.invalidateQueries({
          queryKey: ["get", "/api/teams/{team_slug}/rfqs"],
        });
        await queryClient.invalidateQueries({
          queryKey: ["get", "/api/teams/{team_slug}/rfqs/{id}/full"],
        });

        done(partIdsToSkip);

        if (partIdsToSkip.length === 0) {
          console.error("No parts were skipped, this should not happen.");
        }
      },
    },
  );

  return (
    <ConfirmationModal
      onCancel={cancel}
      isPending={isPending}
      onConfirm={() => {
        mutate({
          params: {
            path: {
              team_slug: teamSlug!,
              id: partId,
            },
          },
        });
      }}
    >
      All child estimates must be completed before parent.
      <br />
      Do you want to mark parent and all children complete?
    </ConfirmationModal>
  );
}
